import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import ViewRiasedTicket from "./ViewRiasedTicket";

const ViewRiasedTicketMain = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t("grievance-details")}
          fileName="DistrictWiseBranches"
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
          backPathForViewTickets={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <ViewRiasedTicket />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewRiasedTicketMain;
